module.exports = __webpack_public_path__ + "static/media/Jam-jar-mockup-10.3a6cc33e.png";